/**
 * Primera + última inicial del nombre completo (o "?" si viene vacío).
 *
 * Vive suelta y no dentro de `InitialsAvatar` porque hay dos avatares con
 * pinta distinta que necesitan las MISMAS iniciales: el del DS (tokens
 * `bg-primary/10`) y el del sidebar (gradiente propio). Duplicar la regla
 * dejaría que un día un avatar mostrara "JP" y el otro "J".
 */
export function obtenerIniciales(nombre: string): string {
  const palabras = nombre.trim().split(/\s+/).filter(Boolean);
  if (palabras.length === 0) return "?";
  const primera = palabras[0]![0];
  const ultima = palabras.length > 1 ? palabras[palabras.length - 1]![0] : "";
  return `${primera}${ultima}`.toUpperCase();
}
